export default {"src":"/_next/static/media/listingbackground.7c8491bb.svg","height":169,"width":80,"blurWidth":0,"blurHeight":0};